import React from "react";

export const Logo = ({ light = false, className = "" }) => (
  <img
    data-testid="vaya-logo"
    src={light ? "/vaya-logo-light.png" : "/vaya-logo.png"}
    alt="Vaya Holidays"
    className={`h-11 sm:h-12 w-auto object-contain ${className}`}
  />
);
